export default [
    {
        "history": true,
        "tradeLink": true,
        "salDefUpdate": true,
        "autoIncrease": true,
        "mixUpdate": true,
        "exchange": true,
        "loanByPhone": true,
        "loanInquiry": true,
        "enroll": true,
        "autoRebal": true,
        "onlineBeneficiary": true,
        "allowBeneficiaryUpdates": true,
        "autoCheck": false,
        "rdfType": 13,
        "smartDollar": false,
        "rothRollover": false,
        "retirementDateFunds": false,
        "tracPlan": false,
        "autoEnrollment": true,
        "onLineStatements": true,
        "confirmationAndProspectuses": true,
        "employeeContributionsAge50CatchUp": false,
        "planTypeCode": "0",
        "channelActivationDate": "2001-01-02T05:00:00.000+00:00",
        "fundMarketInfo": true,
        "prices": true,
        "planNumber": "805222",
        "paperlessStatement": true,
        "paperlessPlanFeeDisclosures": true,
        "paperlessPlanLegalNotices": true,
        "paperlessProxyStatement": false,
        "dividendPassThroughEligibility": false,
        "isPlanNonQualified": false
    }
]